'use client'

import Image from 'next/image'
import s from './style.module.scss'
import Link from 'next/link'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {OtherProducts} from '@app/components/sidebar/other-products/products-data'

type Props = {
  iconSrc: string
  name: OtherProducts
  desc: string
  interrelatedLink: string
}

const Product = ({iconSrc, name, desc, interrelatedLink}: Props) => {
  return (
    <Link
      href={interrelatedLink}
      prefetch={false}
      className={s.product_container}
      target='_blank'
      onClick={triggerAnalytics('other-product-link-clicked', {layout: 'side-menu', 'product-name': name}).sendAll}
    >
      <div className={s.product_icon_text_container}>
        <Image src={iconSrc} alt='other products logo' width={30} height={30} />
        <p className={s.product_text}>
          {name}
          <span className={s.product_sub_text}>{desc}</span>
        </p>
      </div>

      <Image
        src='https://static.gamezop.com/comet/assets/img2/siderbar-products-arrow.svg'
        alt='link arrow'
        width={13}
        height={13}
        className={s.link_arrow}
      />
    </Link>
  )
}

export default Product
